import * as React from 'react';

export const JSONCodeEditor = React.lazy(() =>
    import('./JSONCodeEditor.lazy').then((module) => ({
        default: module.JSONCodeEditor,
    }))
);
